import { makeStyles } from 'tss-react/mui';

const useStylesScrollableContainer: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  scrollableContainer: {
    minHeight: 250,
    maxHeight: 400,
    overflowY: 'scroll !important',
    borderBottom: `1px solid ${theme.palette.info.main}`,
    [theme.breakpoints.down('sm')]: {
      minHeight: 0,
    },
  },
  scrollableContainerEmpty: {
    minHeight: 150,
  },
}));

export default useStylesScrollableContainer;
